(function () {
  'use strict';
  var items = document.querySelectorAll('.home-faq__item');
  items.forEach(function (item) {
    var btn = item.querySelector('.home-faq__q');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var wasOpen = item.classList.contains('is-open');
      items.forEach(function (i) { i.classList.remove('is-open'); });
      if (!wasOpen) item.classList.add('is-open');
    });
  });
})();
